<footer class="footer">
  <div class="footer-content">
    <div class="footer-column footer-left">
      <a
        class="footer-text footer-link"
        href="https://ewents.io"
        target="_blank"
        rel="noopener noreferrer"
      >
        TechWents LLC © {{ getCurrentYear() }}. All rights reserved.
      </a>
    </div>

    <div class="footer-column footer-center">
      <img src="/ewents-logo-navy.svg" alt="Ewents Logo" class="footer-logo" />
    </div>

    <div class="footer-column footer-right">
      <span class="footer-text">Designed by Ewents in Argentina.</span>
    </div>
  </div>
</footer>
